import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import TamanhoService from "./tamanhoService"
import FormList from 'base/FormList'

export default function TamanhoList() {

    const [service] = useState(() => new TamanhoService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_tam',
        dsName: 'descricao_tam',
        mainField: { name: 'descricao_tam', label: 'Descrição' },
        advFields: [
            { name: 'codigo_tam', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_tam', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="descricao_tam" sortable header="Descrição"></Column>
        </FormList >
    )
}
